// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_a142f18","input":"_caec242","icon":"_307c5ec","label":"_0609698","name":"_b5e589f","checked":"_ca2e5b1"};